// TODO refactor
// stores string values for checklist item types ("TRAVEL_DOC", "ONWARD_TICKET")
// - for specific business logic when need to compare PaxCheck API outputs by text value.
// Different from AllowedDocumentType (PASSPORT)
// -> the TRAVEL_DOC value will be gone as part of further refactoring, when we
// drift away from a notion of Passport in webview towards general Travel document
export enum ChecklistItemType {
  TravelDoc = "TRAVEL_DOC",
  OnwardTicket = "ONWARD_TICKET",
}
